export default __webpack_public_path__ + "static/media/snow-2-night.e2cf39cc.svg";